import React, { useContext, useState } from 'react';
import { Link , useHistory} from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';
import { me } from '../../services/authSvc';

import './Login.scss'

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState('');
  const [isValidEmail, setEmailValidity] = useState(false)
  const { login } = useContext(AuthContext);
  const history = useHistory()

  const ValidateEmail = (email) => {
      return /\S+@\S+\.\S+/.test(email)
  }

  const handleEmail = (email) => {
      setEmailValidity(ValidateEmail(email.target.value))
  }

  const handleChange = (evt) => {
    if (evt && evt.target) {
      const { name, value } = evt.target;
      switch (name) {
        case 'email':
          setEmail(value);
          break;
        case 'password':
          setPassword(value);
          break;
        default:
          break;
      }
    }
  };

  const submit = async () => {
    setLoading('logging in...');
    try {
      await login(email, password);
      await me();
      setLoading(null);
      history.push('/')
    } catch (err) {
      setLoading('login failed');
      setTimeout(() => setLoading(null), 1000);
    }
  };

  return (
    <div className="login-panel">
      <div className="login-logo"></div>
      <form className="login-form" noValidate>
        <label></label>
        <input type="email" name="email" value={email} onChange={(e) => handleChange(e)} placeholder="Email" onBlur={(e)=> handleEmail(e)} className={`${isValidEmail ? "valid-email" : ""}`} />

        <label></label>
        <input type="password" name="password" value={password} onChange={(e) => handleChange(e)} placeholder="Password" />
        <p>Forgot password?</p>
      </form>
      <button type="submit" onClick={() => submit()} disabled={!email || !password || !!loading}>
        Login
      </button>
      <p>Don{`'`}t have an account? <Link to="/signup"><span>Sign up</span></Link> </p>
      <section className="social-wrapper">
      <Link to="/signup"><div className="social-media-box google"></div></Link>
      <Link to="/signup"><div className="social-media-box facebook"></div></Link>
      <Link to="/signup"> <div className="social-media-box apple"></div></Link>
       
      </section>
    </div>
  ) 
};

export default LoginPage;
